/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
// $FlowFixMe
import { Modal } from '@bijie/react-bnb';

import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import FlexBox from '../FlexBox';
import RegisterForm from './RegisterForm';

const RegisterBox = styled(FlexBox)`
  width: 100%;
  color: #212833;
  margin-top: -50px;
`;

const Content = styled(FlexBox)`
  background: #fff;
  padding: 35px 40px;
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-size: 34px;
  line-height: 50px;
  margin-bottom: 40px;
  text-align: center;
`;

type Props = {
  i18n: Object,
  isOpenRegister: boolean,
  isAllowedToRegister: boolean,
};

const mapStateToProps = ({ isOpenRegister, isAllowedToRegister }) => ({
  isOpenRegister,
  isAllowedToRegister,
});
export default
@withI18n
@connect(mapStateToProps)
class Register extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  async componentDidMount() {
    const { i18n, isOpenRegister, isAllowedToRegister } = this.props;
    if (!isAllowedToRegister) {
      Modal.info({
        icon: (
          <img
            src={require('./forbidentReg.jpg')}
            alt={getLabel('exchange-register-forbiddent', i18n)}
          />
        ),
        content: getLabel('exchange-register-forbidentRegistTip', i18n),
        okText: getLabel('exchange-register-IUnderstood', i18n),
      });
    }

    if (!isOpenRegister) {
      Modal.info({
        icon: (
          <img
            src={require('./forbidentReg.jpg')}
            alt={getLabel('exchange-register-forbiddentToRegister', i18n)}
          />
        ),
        content: getLabel(
          'exchange-register-pauseRegistrationWhenUpgrading',
          i18n
        ),
        okText: getLabel('exchange-register-IUnderstood', i18n),
      });
    }
  }

  render() {
    const { i18n } = this.props;

    return (
      <RegisterBox direction="column">
        <Title>{getLabel('exchange-register-title', i18n)}</Title>
        <Content>
          <RegisterForm />
        </Content>
      </RegisterBox>
    );
  }
}
